module.exports = __webpack_public_path__ + "assets/img/0620.9d0983dd.svg";